import { useEffect } from "react"
import { BrowserRouter, Route, Routes } from "react-router-dom"

import ListProducts from "../Products/ListProducts.js"
import ViewProduct from "../Products/ViewProduct.js"
import CreateProduct from "../Products/CreateProduct.js"
import EditProduct from "../Products/EditProduct.js"




export default function Products() {

    return (
        <Routes>
            <Route path="/" element={<ListProducts />} />
            <Route path="/view/:id" element={<ViewProduct />} />
            <Route path="/edit/:id" element={<EditProduct />} />
            <Route path="/create/" element={<CreateProduct />} />
        </Routes>
    )
}


